<template>
  <div id="app" :class="{ 'app--login': isLoginPage, 'app--index': isIndexLayout }">
    <header class="app-header" v-if="showStandaloneHeader">
      <div class="header-left">
        <img src="./assets/logo/byyl-logo1.png" class="logoImg" alt="白医云"/>
        <span class="header-divider"></span>
        <span class="header-subtitle">中心端工作台</span>
      </div>

      <div class="header-center" v-if="isLogin">
        <div class="status-card">
          <span class="status-dot" :class="onlineStatus === '0' ? 'status-dot--online' : 'status-dot--offline'"></span>
          <span class="status-label">当前状态</span>
          <el-button
            :type="onlineStatus === '1' ? 'primary' : 'danger'"
            size="mini"
            round
            @click="doctorStatusChange">
            {{ onlineStatus === '1' ? '点击上线' : '点击下线' }}
          </el-button>
          <el-button
            size="mini"
            round
            plain
            icon="el-icon-time"
            @click="showVisitTimeDialog">
            设置就诊时间
          </el-button>
        </div>
      </div>

      <div class="header-right" v-if="isLogin">
        <el-dropdown class="user-dropdown" trigger="click">
          <div class="user-info">
            <img :src="avatarFilePath" class="profileImg" alt="头像">
            <div class="user-meta">
              <span class="user-name">{{ user.userName || '医生' }}</span>
              <span class="user-role">医疗中心端</span>
            </div>
            <i class="el-icon-arrow-down user-arrow"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>

    <main class="app-main">
      <router-view/>
    </main>
    <el-dialog class="dialog-print1" title="提示" :visible.sync="passwordVisible" width="30%" :before-close="handlePassClose">
      <div>
        <el-form ref="passForm" :model="passForm" :rules="passRules" label-width="120px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="签名密码" prop="passwordName">
                <el-input type="password" size="medium" v-model="passForm.passwordName" show-password></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePassClose">取 消</el-button>
        <el-button type="primary" @click="passwordSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设置就诊时间对话框 -->
    <el-dialog title="修改咨询时间" :visible.sync="visitTimeVisible" width="30%" :before-close="handleVisitTimeClose">
      <div>
        <el-form ref="timeForm" :model="timeForm" :rules="timeRules" label-width="80px">
          <el-form-item label="时间" prop="time">
            <div class="time-picker-container">
              <el-time-picker
                v-model="timeForm.beginTime"
                placeholder="开始时间"
                size="small"
                style="width: 120px"
                format="HH:mm:ss">
              </el-time-picker>
              <span class="time-separator">至</span>
              <el-time-picker
                v-model="timeForm.endTime"
                placeholder="结束时间"
                size="small"
                style="width: 120px"
                format="HH:mm:ss">
              </el-time-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleVisitTimeClose">取 消</el-button>
        <el-button type="primary" @click="submitVisitTime">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import {getInfo,getOnlineStatusFlag,updateOnlineFlag} from '@/api/login';
  import SockJS from "sockjs-client";
  import Stomp from "stompjs";
  import {getSignInfo, updateDoctorVisitTime, getDoctorVisitTime} from '@/api/center/myDoctors'
  import {getConsultInfoDetail} from '@/api/center/video'
  const headers = {
    login: 'mylogin',
    passcode: 'mypasscode',
    // additional header
    'client-id': 'my-client-id',
    Author: '1235465tyrgw32rsgg'
  };
  export default {
    name: 'App',
    computed: {
      isLoginPage() {
        return this.$route.path === '/login';
      },
      isIndexLayout() {
        return this.$route.matched.some(function (record) {
          return record.name === 'layout'
        })
      },
      showStandaloneHeader() {
        return !this.isLoginPage && !this.isIndexLayout;
      }
    },
    data() {
      return {
        onlineStatus:'0',
        passForm:{
          passwordName:''
        },
        passRules:{
          passwordName: [{required: true, message: '请输入医师签名密码', trigger: 'blur'}],
        },
        timeForm: {
          beginTime: new Date(new Date().setHours(7, 0, 0)),
          endTime: new Date(new Date().setHours(21, 0, 0))
        },
        timeRules: {
          time: [{ required: true, message: '请选择时间范围', trigger: 'change' }]
        },
        passwordVisible: false,
        visitTimeVisible: false,
        flowDetail: null,
        avatarFilePath:'',
        isLogin: false,
        offsetVale: 8,
        username:'',
        user:{},
        stompClient: null,
        socket: null,
        socketUrl: process.env.VUE_APP_SOCKJS_URL + '/endpoint-centor', // ws://localhost:8080/websocket/ws
      };
    },
    methods: {
      //获取医生上下线状态
      getOnlineFlag(){
        getOnlineStatusFlag({
          doctorId:localStorage.getItem("public-doctor-userId")
        }).then(response => {
          console.log("getOnlineStatusFlag",response)
          if (response.code === 0) {
            this.onlineStatus = response.data + ""
          }
        })
      },
      //改变医生上下线状态
      doctorStatusChange(){
        // 调用API
        updateOnlineFlag({
          doctorId:localStorage.getItem("public-doctor-userId"),
          onlineFlag:this.onlineStatus === '0' ? '1' : '0'
        }).then(response => {
          if (response.code === 0) {
            this.getOnlineFlag();
          }
        })
      },
      initWebsocket() {
        /*
        ① 创建sockJS对象；
        ② 创建stomp客户端
        ③ stompClient客户端 连接 stomp服务器
        */
        this.socket = new SockJS(this.socketUrl)
        this.stompClient = Stomp.over(this.socket)

        this.stompClient.connect(
          headers, // headers头部信息。可添加客户端的认证信息。也可以不添加信息，headers 直接就设置为 {}
          frame => {
            // 连接成功： 订阅服务器的地址。为了浏览器可以接收到消息，必须先订阅服务器的地址
            this.connectSucceed()
          }, err => {
            // 连接失败的回调
            this.reconnect(this.socketUrl, this.connectSucceed)
          })
      },
      /* 连接成功的回调：订阅服务器的地址。为了浏览器可以接收到消息，必须先订阅服务器的地址 */
      connectSucceed() {
        // 设置心跳发送接受频率（ms）默认为10000ms。 heart-beating是利用window.setInterval()去规律地发送heart-beats或者检查服务端的heart-beats。
        this.stompClient.heartbeat.outgoing = 100000
        this.stompClient.heartbeat.incoming = 10000
        this.stompClient.subscribe('/topic/centor', res => {
          console.log("xxxxx问诊信息来了====================",res.body);
          let result = JSON.parse(res.body);
          if(result.data == '1002'){ // 图文问诊
            // 跳转路由 数据不同步 3秒后查询im信息
            setTimeout(()=>{
              console.log(result);
              console.log("问诊信息",result.title);
              // 查询问诊信息
              getConsultInfoDetail(result.title).then(resp=>{
                console.log("问诊信息111111",resp);
                this.flowDetail = resp.data
                // 自己的任务才提示
                if(this.flowDetail.doctorId == localStorage.getItem('public-doctor-userId')){
                  console.log("是我的任务")
                  this.consultMessageNotify(resp.data);
                }
              })


            },3000)

          }

          /* window.setTimeout(() => {
           }, 500);*/
        })

        /*
        当客户端与服务端连接成功后，可以调用 send()来发送STOMP消息。这个方法必须有一个参数，用来描述对应的STOMP的目的地。
        另外可以有两个可选的参数：headers，object类型包含额外的信息头部；body，一个String类型的参数。

        client.send("/queue/test", {priority: 9}, "Hello, STOMP");
        // client会发送一个STOMP发送帧给/queue/test，这个帧包含一个设置了priority为9的header和内容为"Hello, STOMP"的body。
        */
        this.stompClient.send('/topic/dashboard/send', {}, '1')
      },
      consultMessageNotify(flowDetail){
        const h = this.$createElement;
        this.$notify({
          title: '在线问诊实时信息',
          message: h('p', undefined,  [
            h('div', {
              style: 'color: #42b983;font-size:16px;font-weight: bolder; line-height:30px'
            }, flowDetail.customerName),
            h('div',{
              style: 'font-size:16px;cursor: pointer; line-height:30px;padding:0px 10px 0 0'
            }, flowDetail.diseaseDescription)
          ]),
          position: 'bottom-left',
          duration: 10000,
          onClick: () => {
            this.handleCASign();
          }
        });
      },
      quickStartChat(signInfo){
        const userID = localStorage.getItem("phone")
        if(! userID){
          return this.msgError("签名手机号为空");
        }
        // 开始做业务吧
        if(this.flowDetail){
          // 处理问诊图片
          let pics = this.flowDetail.picturePaths;
          if(pics){
            let arr = []
            for(let i=0;i<pics.length;i++){
              let path = pics[i];
              arr.push(this.downloadServer + path);
            }
            this.flowDetail.imgArr = arr;
          }
          console.log("处理的图片",this.flowDetail)
          // 开始做业务吧
          let data = {
            "userID": signInfo.centerPhone,
            "certPassword": signInfo.certPassword
          }
          console.log(data);
          getSignInfo(data).then(resp=>{
            console.log(resp)
            if(resp.code == 0){
              let routerPath = { name: 'timChat',
                params: {
                  rxId: this.flowDetail.rxId,
                  patientId: this.flowDetail.patientId,
                  customerId: this.flowDetail.customerId,
                  customerName:this.flowDetail.customerName,
                  customerAvatar:this.flowDetail.customerAvatar,
                  lastInterrogationItem: this.flowDetail,
                  doctorSignUrl: "data:image/gif;base64," + resp.data.data.mergeImage,
                }
              }
              this.$router.push(routerPath);
            }else{
              this.$message({
                type: 'error',
                message: resp.msg
              });
            }

          })


          /*// 显示签名密码信息
          this.$prompt('请输入签名密码', '提示', {
            confirmButtonText: '确定',
            inputType:'password',
            cancelButtonText: '取消',
          }).then(({ value }) => {


          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });*/
        }
      },
      handleCASign(){
        this.passwordVisible = true;
      },
      passwordSubmit(){
        this.$refs['passForm'].validate((valid) => {
          if (valid) {
            this.tableLoading = true;
            let signInfo = {
              certPassword: this.passForm.passwordName,
              centerPhone: localStorage.getItem("phone"),
            };
            this.handlePassClose()
            this.quickStartChat(signInfo);
          } else {
            return false;
          }
        });
      },
      handlePassClose(){
        this.passwordVisible = false
        this.passForm = {
          passwordName:''
        }
      },
      // 显示设置就诊时间对话框
      showVisitTimeDialog() {
        // 获取当前医生的就诊时间设置
        this.fetchDoctorVisitTime();
        this.visitTimeVisible = true;
      },
      // 获取医生就诊时间
      fetchDoctorVisitTime() {
        const data = {
          id: this.user.id || "1848526547804246018"
        };
        getDoctorVisitTime(data).then(response => {
          if (response.code === 0 && response.data) {
            // 将字符串格式时间转换为Date对象
            const parseTimeToDate = (timeStr) => {
              const now = new Date();
              const [hours, minutes, seconds] = timeStr.split(':').map(Number);
              return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);
            };

            if (response.data.visitBeginTime) {
              this.timeForm.beginTime = parseTimeToDate(response.data.visitBeginTime);
            }

            if (response.data.visitEndTime) {
              this.timeForm.endTime = parseTimeToDate(response.data.visitEndTime);
            }
          }
        }).catch(error => {
          console.error('获取就诊时间失败:', error);
        });
      },
      // 关闭设置就诊时间对话框
      handleVisitTimeClose() {
        this.visitTimeVisible = false;
      },
      // 提交就诊时间
      submitVisitTime() {
        // 格式化时间为HH:mm:ss格式
        const formatTime = (date) => {
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          const seconds = date.getSeconds().toString().padStart(2, '0');
          return `${hours}:${minutes}:${seconds}`;
        };

        const beginTimeStr = formatTime(this.timeForm.beginTime);
        const endTimeStr = formatTime(this.timeForm.endTime);

        const data = {
          id: this.user.id || "1848526547804246018", // 使用当前登录医生ID或默认ID
          visitBeginTime: beginTimeStr,
          visitEndTime: endTimeStr,
          allValue: [
            beginTimeStr,
            endTimeStr
          ]
        };

        // 调用API
        updateDoctorVisitTime(data).then(response => {
          if (response.code === 0) {
            this.$message({
              type: 'success',
              message: '就诊时间设置成功'
            });
          } else {
            this.$message({
              type: 'error',
              message: response.msg || '就诊时间设置失败'
            });
          }
          this.handleVisitTimeClose();
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '就诊时间设置失败: ' + error
          });
          this.handleVisitTimeClose();
        });
      },
      async logout() {
        this.$confirm('确定注销并退出系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.removeToken();
          sessionStorage.clear();
          localStorage.clear();
          location.href = '/';
        })
      }
    },
    created() {
      const adminToken = this.getToken();
      const user = this.getDataFromCookie("user");
      console.log('admin-center-token='+adminToken);
      console.log(user,"user");
      if(adminToken){
        this.isLogin = true;
        // 获得用户信息
        getInfo().then(response=>{
          console.log("主页-获得用户信息");
          console.log(response);
          if(response.code==0){
            this.user = response.data;
            // 头像  response.data.avatarFilePath
            let filePath = process.env.VUE_APP_DOWNLOAD_SERVER + response.data.avatarFilePath;
            this.avatarFilePath = response.data.avatarFilePath?filePath:require("@/assets/images/profile.png");
            console.log(this.avatarFilePath,'this.avatarFilePath');

            // 登录成功后获取医生就诊时间
            this.fetchDoctorVisitTime();
          }
        });
        this.getOnlineFlag();
      }else{
        this.isLogin = false;
      }
    },
    mounted(){
      const appEl = document.getElementById("app");
      if (appEl) {
        appEl.style.height = "100vh";
        appEl.style.minHeight = "100vh";
      }
      // this.initWebsocket();
    }
  }
</script>

<style>
  /* ===== 应用壳层 ===== */
  #app {
    font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #1f2937;
    min-height: 100vh;
    background-color: #f5f7fb;
    display: flex;
    flex-direction: column;
  }

  #app.app--login,
  #app.app--index {
    background: #f5f7fb !important;
    min-height: 100vh;
    height: 100vh !important;
  }

  #app.app--index .app-main {
    height: 100vh;
  }

  .app-main {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* ===== 顶栏 ===== */
  .app-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    box-shadow: 0 1px 8px rgba(15, 23, 42, 0.06);
    flex-shrink: 0;
    z-index: 100;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .logoImg {
    height: 36px;
    width: auto;
    object-fit: contain;
  }

  .header-divider {
    width: 1px;
    height: 20px;
    background: #e5e7eb;
  }

  .header-subtitle {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
  }

  .header-center {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .status-card {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 20px;
    padding: 4px 16px 4px 12px;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .status-dot--online {
    background: #52c41a;
    box-shadow: 0 0 0 3px rgba(82, 196, 26, 0.2);
    animation: pulse-online 2s infinite;
  }

  .status-dot--offline {
    background: #ff4d4f;
    box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.2);
  }

  @keyframes pulse-online {
    0%, 100% { box-shadow: 0 0 0 3px rgba(82, 196, 26, 0.2); }
    50% { box-shadow: 0 0 0 6px rgba(82, 196, 26, 0.1); }
  }

  .status-label {
    font-size: 13px;
    color: #6b7280;
  }

  .header-right {
    display: flex;
    align-items: center;
  }

  .user-dropdown {
    cursor: pointer;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 8px;
    border-radius: 8px;
    transition: background 0.2s;
  }

  .user-info:hover {
    background: #f3f4f6;
  }

  .profileImg {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #e5e7eb;
  }

  .user-meta {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .user-name {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
  }

  .user-role {
    font-size: 11px;
    color: #9ca3af;
  }

  .user-arrow {
    font-size: 12px;
    color: #9ca3af;
    margin-left: 4px;
  }

  /* Time picker styles */
  .time-picker-container {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .time-separator {
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue